import styled from "styled-components";
import Slider from "react-rangeslider";

const SIZE = 22;
const WIDTH = 1;

export const RangeSlider = styled(Slider)`
  &.rangeslider {
    position: relative;
    margin: ${0.5 * SIZE + 4}px 0;
    height: 0;
    border: ${WIDTH}px solid #e3e3e3;
    border-radius: ${WIDTH}px;
  } 

  .rangeslider {
    &__fill {
      position: absolute;
      left: -${WIDTH}px;
      top: -${WIDTH}px;
      border: ${WIDTH}px solid ${({ theme: { colors } }) => colors["sp-blue"]};
      border-radius: ${WIDTH}px 0 0 ${WIDTH}px;
    }
    
    &__handle {
      position: absolute;
      content: ' ';
      top: 50%;
      width: ${SIZE}px;
      height: ${SIZE}px;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.2);
      outline: none;
      transform: translate(-${0.5 * SIZE + WIDTH}px, -50%);
      cursor: pointer;
    }

    &__labels {
      margin: 0;
      display: none;
    }
  }
`;
